import { Fragment } from 'react';
import {
  PopoverArrow,
  PopoverBody,
  PopoverBodyProps as ChakraPopoverBodyProps,
  PopoverContent as ChakraPopoverContent,
  Portal,
  usePrefersReducedMotion,
} from '@chakra-ui/react';
import { usePopoverContext } from './Popover.context';

export interface PopoverContentProps extends ChakraPopoverBodyProps {
  withoutPortal?: boolean;
}

const PopoverContent = ({ children, withoutPortal, ...rest }: PopoverContentProps) => {
  const Wrapper = withoutPortal ? Fragment : Portal;

  const { withArrow } = usePopoverContext();

  const prefersReducedMotion = usePrefersReducedMotion({ ssr: false });

  return (
    <Wrapper>
      <ChakraPopoverContent
        motionProps={
          prefersReducedMotion
            ? {
                variants: {
                  enter: {
                    visibility: 'visible',
                    opacity: 1,
                    transition: {
                      duration: 0,
                    },
                  },
                  exit: {
                    transitionEnd: {
                      visibility: 'hidden',
                    },
                    opacity: 0,
                    transition: {
                      duration: 0,
                    },
                  },
                },
              }
            : undefined
        }
      >
        {withArrow && <PopoverArrow />}
        <PopoverBody {...rest}>{children}</PopoverBody>
      </ChakraPopoverContent>
    </Wrapper>
  );
};

export default PopoverContent;
